import {ValidationType} from '~shared/ng/modules/validation/enum/validation-type';

export type ServerError = {
    message: string,
    type: ServerErrorType,
};

export enum ServerErrorType {
    COMMON_ERROR = 'common_error',
    VALIDATION_ERROR = 'validation_error',
}

export type ValidationServerError = ServerError & {
    type: ServerErrorType.VALIDATION_ERROR,
    details: Array<ValidationErrorDetail>
};

export type RuleConstraint = {
    message: string;
    type: ValidationType,
    [key: string]: any,
}

export type PrimitiveParamErrorDetail = {
    // Param name or index
    paramName: string,
    errorMessage: string,
}

export type ModelValidParamErrorDetail = {
    // Path to param | example - body.deviceInfo.browser
    key: string,
    constraint: ErrorDetailConstraint
}

export type ErrorDetailConstraint = RuleConstraint & {
    // Context - Validation model/ undefined if value is primitive
    context: string,
    key: string,
}

export type ExistingConstraintErrorDetail = {
    key: string,
    existingConstraint: true
}

export type ModelInvalidParamErrorDetail = ModelValidParamErrorDetail & {
    errorMessage: string,
}

export type ValidationErrorDetail = PrimitiveParamErrorDetail | ModelInvalidParamErrorDetail | ModelValidParamErrorDetail | ExistingConstraintErrorDetail


export function isValidationErrorException($: any): $ is ValidationServerError {
    return typeof $ === 'object'
        && $ !== null
        && $.type === ServerErrorType.VALIDATION_ERROR
        && Array.isArray($.details);
}

export function isPrimitiveParamErrorDetail($: any): $ is PrimitiveParamErrorDetail {
    return typeof $ === 'object'
        && $ !== null
        && $.hasOwnProperty('paramName')
        && $.hasOwnProperty('errorMessage')
}

export function isModelInvalidParamErrorDetail($: any): $ is ModelInvalidParamErrorDetail {
    return typeof $ === 'object'
        && $ !== null
        && $.hasOwnProperty('key')
        && $.hasOwnProperty('errorMessage')
        && $.hasOwnProperty('constraint')
}

export function isExistingConstraintErrorDetail($: any): $ is ExistingConstraintErrorDetail {
    return typeof $ === 'object'
        && $ !== null
        && $.hasOwnProperty('key')
        && $.hasOwnProperty('existingConstraint')
}

export function isModelValidParamErrorDetail($: any): $ is ModelValidParamErrorDetail {
    return typeof $ === 'object'
        && $ !== null
        && $.hasOwnProperty('key')
        && !$.hasOwnProperty('errorMessage')
        && $.hasOwnProperty('constraint')
}

// Body -> Model
export const BodyModelError: ValidationServerError = {
    message: 'validation FaIIIILED',
    type: ServerErrorType.VALIDATION_ERROR,
    details: [
        {
            key: 'login',
            errorMessage: 'Value must be equal or longer then 2.',
            constraint: {
                key: 'login',
                context: 'LoginDto',
                message: 'Value must be equal or longer then {{ min }}.|Value must not exceed {{ max }}.',
                type: ValidationType.SIZE,
                min: 2,
                max: 12,
            }
        },
        {
            key: 'login',
            constraint: {
                key: 'login',
                context: 'LoginDto',
                message: 'This field is required.',
                type: ValidationType.REQUIRED,
            }
        },
    ]
};
// Param(s) -> Rule(s)
const ParamsRulesError: ValidationServerError = {
    message: 'validation FaIIIILED',
    type: ServerErrorType.VALIDATION_ERROR,
    details: [
        {
            paramName: 'email',
            errorMessage: 'Value must be equal or longer then 2.',
        },
        {
            paramName: 'password',
            errorMessage: 'Value must be equal or longer then 2.',
        }
    ]
};

